<script lang="ts" setup>
  import type { Sort } from '~/core/types/Sort.enum'

  type Props = {
    isFetching?: boolean
    count: number
    sortTypes: Sort[]
  }
  const props = defineProps<Props>()
  const sortType = defineModel<Sort>('sortType', { required: true })
  const showMap = defineModel<boolean>('showMap', { required: true })
  const { matches: matchDesktop } = useMatchMedia(ScreenWidth.desktop)
  const { t } = useI18n()

</script>
<template>
  <div
    class="head"
    :class="{ 'map-displayed': showMap }"
  >
    <div class="list-head">
      <div class="amount">
        <span v-if="props.isFetching">
          {{ t("products.no-results") }}
        </span>
        <span v-else-if="props.count">
          {{ t("products.results", props.count) }}
        </span>
        <span v-else>{{ t("products.no-results") }}</span>
      </div>
      <div class="sort">
        <select
          ref="sort"
          v-model="sortType"
        >
          <option
            disabled
            selected
            value=""
          >
            Trier
          </option>
          <option
            v-for="(option, k) in props.sortTypes"
            :key="k"
          >
            {{ option }}
          </option>
        </select>
        <span class="arrow" />
      </div>
    </div>
    <div
      v-show="matchDesktop"
      class="map-head"
    >
      <p class="display-map">
        <span>Afficher la carte</span>
      </p>
      <InputSwitch
        v-model="showMap"
      />
    </div>
  </div>
</template>
<style scoped>
  .head {
    position: sticky;
    z-index: 1;
    top: var(--search-height);
    display: flex;
    height: 3.5em;
    flex: 0 0 auto;
    flex-direction: row;
    justify-content: space-between;
    background-color: white;
    transition: top 0.3s ease-out;

    .list-head {
      display: flex;
      flex: 1 1 100%;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;

      .amount {
        span {
          color: var(--color-secondary);
          font-family: Open-Sans, sans-serif;
          font-size: 1.125em;
          font-weight: bold;
          opacity: 0.4;
        }
      }

      .sort {
        position: relative;

        select {
          position: relative;
          width: 100%;
          padding-right: 1em;
          border: none;
          appearance: none;
          background-color: white;
          color: var(--color-secondary);
          font-family: Open-Sans, sans-serif;
          font-size: 0.875em;
          font-weight: 400;
          opacity: 0.8;
        }

        .arrow {
          position: absolute;
          top: calc(50% - 2px);
          right: 0;
          display: inline-block;
          width: 0;
          height: 0;
          border-top: 6px solid var(--color-secondary);
          border-right: 4px solid transparent;
          border-left: 4px solid transparent;
          margin: 0 0 2px 12px;
          opacity: 0.8;
          pointer-events: none;
        }
      }
    }
  }

  @media screen and (width >= 1024px) {
    .head {
      height: 90px;
      align-items: center;
      padding: 1.5em 0;
      margin: 0;
      background-color: white;

      .list-head {
        flex: 0 0 50%;
        padding: 0 0.75em 0 1.5em;
        background-color: white;

        .amount {
          span {
            font-size: 1.75em;
          }
        }

        .sort {
          margin-left: 2em;

          select {
            font-size: 1.125em;
          }
        }
      }

      .map-head {
        display: flex;
        flex: 0 0 50%;
        flex-direction: row;
        align-items: center;
        justify-content: flex-end;
        padding: 0 0 0 0.75em;
        background-color: white;

        .display-map {
          padding-right: 1.5em;

          span {
            color: var(--color-secondary);
            font-family: Open-Sans, sans-serif;
            font-size: 1.125em;
            font-weight: normal;
            opacity: 0.8;
          }
        }
      }
    }
  }
</style>
